import { useEffect, useState } from "react";
import { X, Volume2, VolumeX } from "lucide-react";

export default function ReelModal({ open, onClose, url, poster }) {
  const [muted, setMuted] = useState(false);
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;
  const src = url?.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`;
  const posterSrc = poster
    ? poster.startsWith("http")
      ? poster
      : `${process.env.REACT_APP_BACKEND_URL}${poster}`
    : undefined;

  return (
    <div
      data-testid="reel-modal"
      data-lenis-prevent
      className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-md flex items-center justify-center p-4 md:p-10 animate-in fade-in overscroll-contain"
      onClick={onClose}
    >
      <button
        data-testid="reel-modal-close"
        onClick={onClose}
        className="absolute top-6 right-6 w-11 h-11 border border-white/20 hover:border-[#ff4500] hover:bg-[#ff4500] flex items-center justify-center transition-all z-10"
        aria-label="Close reel"
      >
        <X size={18} className="text-white" />
      </button>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setMuted((m) => !m);
        }}
        className="absolute top-6 right-20 w-11 h-11 border border-white/20 hover:border-[#ff4500] flex items-center justify-center transition-all text-white z-10"
        aria-label={muted ? "Unmute" : "Mute"}
      >
        {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
      </button>
      <video
        src={src}
        poster={posterSrc}
        autoPlay
        loop
        muted={muted}
        controls
        playsInline
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-6xl aspect-video bg-black"
      />
    </div>
  );
}
